import styled from "styled-components";
import {styledByDevice} from "../../../../../themes/architecture/styled-by-device";
import {ACTIVE} from "../../../../../themes/css-global-classes";

const PCBox = styled.span`

  background-color:${props => props.theme.colors.brandPrimary};
  border-radius: 5px;
  border:1px solid ${props => props.theme.colors.modalDialogBorder};
  width:18px;
  height: 18px;
  margin-right: 5px;
  
  .${ACTIVE} &{
     background-image: url("${props => props.theme.images.spriteSheet.toString()}");
     background-position: -457px -526px;
     background-color: transparent;
     border:none;
  }
`;
const MobileBox = styled.span` 
   background-image: url("${props => props.theme.images.spriteSheet.toString()}");
   background-position: -246px -292px;
   width: 90px;
   height: 90px;

    .${ACTIVE} &{
        background-position: -245px -157px;
    }
`;

export const FilterLinkIconCasino777Box = styledByDevice(PCBox, MobileBox);